// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3YJwy","loaderOuter":"PageOverlayLoader_loaderOuter__1orBg"};